module.exports = __webpack_public_path__ + "static/img/clock.99c0965b.png";